"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK = void 0;
/**
 * This is to help us know what code is affected if we were to change irrigation scheduler to allow a
 * different start of week. e.g. (Monday for Italian users)
 */
exports.IRRIGATION_SCHEDULER_FIRST_DAY_OF_WEEK = 0; // Sunday
//# sourceMappingURL=irrigationScheduler.js.map